// src/config/terminalx.js
//
// TerminalX on the website (enhancements log, 18 Oct 2026): the product page
// at its real route, and the one release it offers. The page copy itself lives
// with the page; only what a release changes is written here, so a new build
// is a one-line edit.
//
// The installer is published on GitHub (RiftWorksApps/terminalx-releases,
// 18 Oct 2026). installerUrl is the stable "latest" address, which never
// changes and always serves the newest setup, so a new release needs no
// change here except the version shown. The download size, checksum and
// release notes come from the repository's downloads manifest: the Downloads
// page shows them all, and the product page reads the live version and
// download size from the same file, falling back to what is written here.
//
// installedSize is what the program takes on disk once installed, which is
// not the download size: the page shows the two side by side so they are
// never confused.

export const TERMINALX_PATH = '/applications/terminalx';

export const TERMINALX_RELEASE = {
  version: '0.2.0',
  file: 'TerminalXSetup.exe',
  installerUrl: 'https://github.com/RiftWorksApps/terminalx-releases/releases/latest/download/TerminalXSetup.exe',
  requirements: 'Windows 10 or 11, 64-bit',
  installedSize: 'about 60 MB',
};
